import React from "react";
import { initials } from "@/lib/format";

export function UserAvatar({ user, size = 40, className = "" }) {
  const style = { width: size, height: size };
  const initialsText = initials(user?.first_name, user?.last_name);
  if (user?.photo_data) {
    return (
      <img
        src={user.photo_data}
        alt={initialsText}
        style={style}
        className={`rounded-full object-cover ring-1 ring-black/5 ${className}`}
        data-testid="user-avatar-image"
      />
    );
  }
  return (
    <div
      style={{ ...style, fontSize: Math.round(size * 0.38) }}
      className={`rounded-full bg-[#B31B1B]/10 text-[#B31B1B] font-semibold flex items-center justify-center ring-1 ring-black/5 ${className}`}
      data-testid="user-avatar-initials"
    >
      {initialsText}
    </div>
  );
}
